import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const DeactivatedEmptyState = ({ height = 128, width = 128, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} data-test="archive-empty-state" {...props}>
    <g clipPath="url(#a)">
      <path
        d="M43.751 113.728a51.2 51.2 0 1 0 40.496-94.052 51.2 51.2 0 0 0-40.496 94.052Z"
        fill={colors.grey5}
      />
      <path
        d="M39.927 105.816c0 .306.602.609 1.773.891 1.17.283 2.885.54 5.047.756 2.162.216 4.729.387 7.554.504 2.825.117 5.853.178 8.91.178 3.058 0 6.086-.061 8.911-.178 2.825-.117 5.392-.288 7.554-.504 2.162-.216 3.877-.473 5.048-.756 1.17-.282 1.772-.585 1.772-.891 0-.305-.602-.608-1.772-.891-1.17-.282-2.886-.539-5.048-.755-2.162-.216-4.729-.388-7.554-.505a217.676 217.676 0 0 0-8.91-.177c-3.058 0-6.086.06-8.911.177-2.825.117-5.392.289-7.554.505-2.162.216-3.877.473-5.047.755-1.17.283-1.773.586-1.773.891Z"
        fill={colors.grey15}
      />
      <path
        d="M98.808 42.088a2.461 2.461 0 0 1-2.461 2.456H29.093a2.463 2.463 0 0 1-.959-4.75 2.46 2.46 0 0 1 .96-.171h67.253a2.462 2.462 0 0 1 2.461 2.465Z"
        fill={colors.purple50}
      />
      <path
        d="M92.8 92.12a6.561 6.561 0 0 1-6.561 6.56H39.208a6.561 6.561 0 0 1-6.561-6.56V44.543H92.8V92.12Z"
        fill={colors.white}
      />
      <path
        d="M41.395 49.47h42.65v14.763h-42.65V49.469ZM41.395 69.153h42.65v22.965h-42.65V69.153Z"
        fill="#FDF5FF"
        stroke={colors.purple100}
        strokeWidth="1.28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.317 101.961a3.282 3.282 0 0 1-3.28 3.281 3.282 3.282 0 0 1-3.281-3.281v-3.28h6.56v3.28Z"
        fill={colors.white}
      />
      <path
        d="M46.317 101.961a3.282 3.282 0 0 1-3.28 3.281 3.282 3.282 0 0 1-3.281-3.281v-3.28h6.56v3.28Z"
        stroke={colors.purple100}
        strokeWidth="1.28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M85.685 101.961a3.283 3.283 0 0 1-3.281 3.281 3.282 3.282 0 0 1-3.28-3.281v-3.28h6.56v3.28Z"
        fill={colors.white}
        stroke={colors.purple100}
        strokeWidth="1.28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M92.8 92.12a6.561 6.561 0 0 1-6.561 6.56H39.208a6.561 6.561 0 0 1-6.561-6.56V44.543H92.8V92.12Z"
        stroke={colors.purple100}
        strokeWidth="1.28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.458 14.155h6.56v25.426h-6.56V14.155ZM37.019 17.436h6.561v22.145H37.02V17.436ZM43.58 14.155h6.562v25.426H43.58V14.155Z"
        fill={colors.white}
        stroke={colors.purple100}
        strokeWidth="1.28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.458 19.076h6.56v3.28h-6.56v-3.28Z"
        fill="#FFF8D9"
        stroke={colors.purple100}
        strokeWidth="1.28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.019 22.356h6.561v3.281H37.02v-3.28Z"
        fill="#FDF5FF"
        stroke={colors.purple100}
        strokeWidth="1.28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.58 19.076h6.562v3.28H43.58v-3.28Z"
        fill={colors.green10}
        stroke={colors.purple100}
        strokeWidth="1.28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m49.97 14.727 6.25-1.532 6.127 24.994-6.249 1.532-6.127-24.994Z"
        fill={colors.white}
        stroke={colors.purple100}
        strokeWidth="1.28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m51.12 19.413 6.248-1.532.766 3.125-6.249 1.531-.765-3.124Z"
        fill="#E6FBFF"
        stroke={colors.purple100}
        strokeWidth="1.28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M78.304 20.762a7.382 7.382 0 1 0 14.764 0 7.382 7.382 0 0 0-14.764 0Z"
        fill={colors.green10}
      />
      <path
        d="m92.645 13.802-1.74 1.74M95.528 20.762h-2.462M78.725 13.802l1.741 1.74M75.843 20.762h2.461M78.304 20.762a7.382 7.382 0 1 0 14.764 0 7.382 7.382 0 0 0-14.764 0Z"
        stroke={colors.purple100}
        strokeWidth="1.28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M82.405 20.762c0 .969.085 1.929.25 2.825.165.895.406 1.709.711 2.394.305.686.666 1.23 1.064 1.6.398.372.825.562 1.256.562.43 0 .857-.19 1.255-.562.398-.37.76-.914 1.065-1.6.304-.685.546-1.499.71-2.395.166-.895.25-1.855.25-2.824 0-.97-.084-1.93-.25-2.825-.164-.896-.406-1.71-.71-2.395-.305-.685-.667-1.23-1.065-1.6-.398-.371-.824-.562-1.255-.562-.431 0-.858.19-1.256.562-.398.37-.76.915-1.064 1.6-.305.685-.546 1.5-.711 2.395-.165.895-.25 1.855-.25 2.825Z"
        stroke={colors.purple100}
        strokeWidth="1.28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M83.226 12.56a2.46 2.46 0 1 0 4.92 0 2.46 2.46 0 0 0-4.92 0Z"
        fill="#FEE5E9"
        stroke={colors.purple100}
        strokeWidth="1.28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M78.336 26.502a1.64 1.64 0 0 0-1.64 1.7c.326 9.228 3.252 11.423 3.252 11.423H91.43s2.927-2.195 3.25-11.423a1.644 1.644 0 0 0-1.638-1.7H78.336Z"
        fill={colors.white}
      />
      <path
        d="M78.336 26.502a1.64 1.64 0 0 0-1.64 1.7c.326 9.228 3.252 11.423 3.252 11.423H91.43s2.927-2.195 3.25-11.423a1.644 1.644 0 0 0-1.638-1.7H78.336Z"
        stroke={colors.purple100}
        strokeWidth="1.28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M70.922 56.851a2.46 2.46 0 0 1-2.461 2.46H56.979a2.46 2.46 0 1 1 0-4.92h11.482a2.461 2.461 0 0 1 2.461 2.46Z"
        fill={colors.white}
      />
      <path
        d="M70.922 56.851a2.46 2.46 0 0 1-2.461 2.46H56.979a2.46 2.46 0 1 1 0-4.92h11.482a2.461 2.461 0 0 1 2.461 2.46v0Z"
        stroke={colors.purple100}
        strokeWidth="1.28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M70.922 76.535a2.462 2.462 0 0 1-2.461 2.462H56.979a2.463 2.463 0 0 1-1.776-4.222 2.462 2.462 0 0 1 1.776-.7h11.482a2.462 2.462 0 0 1 2.461 2.46Z"
        fill={colors.white}
      />
      <path
        d="M70.922 76.535a2.462 2.462 0 0 1-2.461 2.462H56.979a2.463 2.463 0 0 1-1.776-4.222 2.462 2.462 0 0 1 1.776-.7h11.482a2.462 2.462 0 0 1 2.461 2.46v0ZM98.808 42.088a2.461 2.461 0 0 1-2.461 2.456H29.093a2.463 2.463 0 0 1-.959-4.75 2.46 2.46 0 0 1 .96-.171h67.253a2.462 2.462 0 0 1 2.461 2.465v0Z"
        stroke={colors.purple100}
        strokeWidth="1.28"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill={colors.white} d="M0 0h128v128H0z" />
      </clipPath>
    </defs>
  </SvgIcon>
);
